import { render, staticRenderFns } from "./PurchaseOrderForm.vue?vue&type=template&id=0d37a8fc&scoped=true&"
import script from "./PurchaseOrderForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderForm.vue?vue&type=style&index=0&id=0d37a8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37a8fc",
  null
  
)

export default component.exports